import React, { useContext } from "react";
import classnames from "classnames";
import Scroll from "react-scroll";
import { AppContext } from "@vahak/core/dist/app-context";
import Styles from "./Welcome.module.scss";
import AppImg from "components/utils/AppImg";
import AppBtn from "@vahak/core/dist/components/app-btn/AppBtn";

import ArrowRightWhiteIcon from "@vahak/core/dist/icons/arrow-right-white.svg";

const ScrollLink = Scroll.Link;

const Welcome = () => {
    const { isMobile } = useContext(AppContext);

    return (
        <>
            <div className={classnames(Styles.row)}>
                <div className={Styles.textCol}>
                    <h1>
                        Join us and build the largest
                        <span data-hover="B2B Transport Marketplace" className={isMobile ? "" : "indaiText"}>
                            B2B Transport Marketplace
                        </span>
                    </h1>
                    <ScrollLink
                        to={"jobs"}
                        spy={true}
                        smooth={true}
                        duration={0}
                        activeClass="active"
                        // offset={-getHeightByViewPort(74).slice(0, -2)}
                        offset={-"74px".slice(0, -2)}
                    >
                        <AppBtn className={Styles.openPositionBtn}>
                            Open Positions <ArrowRightWhiteIcon />
                        </AppBtn>
                    </ScrollLink>
                </div>
                <div className={Styles.imgCol}>
                    <div className={Styles.imgboxRow}>
                        <div className={Styles.imgbox}>
                            <AppImg
                                src={`offsite-image-banner-2.jpg`}
                                placeholder="empty"
                                alt="Vahak-Jobs"
                                layout="responsive"
                                width={isMobile ? "106" : "178"}
                                height={isMobile ? "160" : "268"}
                                priority
                            />
                        </div>
                        <div className={Styles.imgbox}>
                            <AppImg
                                src={`offsite-image-banner-1.jpg`}
                                placeholder="empty"
                                alt="Vahak-Careers"
                                layout="responsive"
                                width={isMobile ? "205" : "346"}
                                height={isMobile ? "136" : "232"}
                                priority
                            />
                        </div>
                        <div className={Styles.imgbox}>
                            <AppImg
                                src={`offsite-image-banner-3.jpg`}
                                placeholder="empty"
                                alt="Vahak-Jobs"
                                layout="responsive"
                                width={isMobile ? "160" : "271"}
                                height={isMobile ? "106" : "180"}
                                priority
                            />
                        </div>
                        <div className={Styles.imgbox}>
                            <AppImg
                                src={`offsite-image-banner-4.jpg`}
                                placeholder="empty"
                                alt="Vahak-Careers"
                                layout="responsive"
                                width={isMobile ? "142" : "239"}
                                height={isMobile ? "140" : "255"}
                                priority
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={classnames(Styles.ourVision)}>
                <h2>
                    What drives our {""}
                    <span data-hover="Vision" className={isMobile ? "" : "indaiText"}>
                        Vision
                    </span>
                </h2>
                <p>
                    At Vahak, we are on a mission to democratize B2B road transportation for all. We aim to build the
                    largest and most trusted transport marketplace. In an ecosystem where load owners with plenty of
                    requirements struggle to find lorries and truck owners are seldom able to find loads, we want to
                    bridge this gap.
                </p>

                <p>
                    Our goal is to make Vahak India’s go-to-platform for all road transportation and logistics
                    requirements. We’re not just building an app, we’re building a community that’s uniting lakhs of
                    Indian transporters!
                </p>
            </div>
        </>
    );
};

export default Welcome;
